import { AvatarArmsItemNo } from './avatarArms';
import { AvatarAurasItemNo } from './avatarAuras';
import { AvatarBodiesItemNo } from './avatarBodies';
import { AvatarFeetItemNo } from './avatarFeet';
import { AvatarHatsItemNo } from './avatarHats';
import { AvatarNecksItemNo } from './avatarNecks';
import { AvatarWingsItemNo } from './avatarWings';

export const getItemIdString = (type: string, subType: string, id: number) => {
  return `${type}-${subType}-${String(id).padStart(8, '0')}` as AvatarId;
};

export enum AvatarConstant {
  Avatars = 'avatars',
}

export enum AvatarSet {
  Limited = 'limited',
  Regular = 'regular',
  Default = 'default',
}

export enum AvatarCategory {
  Arms = 'arms',
  Auras = 'auras',
  Bodies = 'bodies',
  Feet = 'feet',
  Hats = 'hats',
  Necks = 'necks',
  Wings = 'wings',
}

export enum AvatarItemType {
  Body = 'body',
  Hat = 'hat',
  Arms = 'arms',
  Feet = 'feet',
  Wings = 'wings',
  Neck = 'neck',
  Aura = 'aura',
}

export type UserAvatarCategory = [
  {
    avatarItemId: AvatarBodiesItemNo | null;
    avatarItemType: AvatarCategory.Bodies;
  },
  {
    avatarItemId: AvatarHatsItemNo | null;
    avatarItemType: AvatarCategory.Hats;
  },
  {
    avatarItemId: AvatarArmsItemNo | null;
    avatarItemType: AvatarCategory.Arms;
  },
  {
    avatarItemId: AvatarFeetItemNo | null;
    avatarItemType: AvatarCategory.Feet;
  },
  {
    avatarItemId: AvatarWingsItemNo | null;
    avatarItemType: AvatarCategory.Wings;
  },
  {
    avatarItemId: AvatarNecksItemNo | null;
    avatarItemType: AvatarCategory.Necks;
  },
  {
    avatarItemId: AvatarAurasItemNo | null;
    avatarItemType: AvatarCategory.Auras;
  },
];

export const AvatarCategoryOrder = [
  AvatarCategory.Bodies,
  AvatarCategory.Hats,
  AvatarCategory.Arms,
  AvatarCategory.Feet,
  AvatarCategory.Wings,
  AvatarCategory.Necks,
  AvatarCategory.Auras,
];

export enum AvatarType {
  AvatarArms = 'avatarArms',
  AvatarAuras = 'avatarAura',
  AvatarBody = 'avatarBody',
  AvatarFeet = 'avatarFeet',
  AvatarHat = 'avatarHat',
  AvatarNeck = 'avatarNeck',
  AvatarWings = 'avatarWings',
}

export type AvatarId =
  | AvatarArmsItemNo
  | AvatarAurasItemNo
  | AvatarBodiesItemNo
  | AvatarFeetItemNo
  | AvatarHatsItemNo
  | AvatarNecksItemNo
  | AvatarWingsItemNo
  | null;

type IAvatarVisualTemplate = {
  filePrefix: string;
  thumbnailPrefix?: string;
  frameCount: number;
  hasMask: boolean;
  hasHighlight: boolean;
  hasThumbnail: true;
};

type IAvatarVisual<T> = T extends AvatarCategory.Bodies
  ? IAvatarVisualTemplate
  : Omit<IAvatarVisualTemplate, 'hasHighlight'>;
type AvatarVisual<T> =
  | IAvatarVisual<T>
  | (Omit<IAvatarVisual<T>, 'hasThumbnail'> & {
      hasThumbnail: false;
    });

export type AvatarItem<T extends AvatarCategory> = {
  itemId: Exclude<AvatarId, null>;
  category: AvatarConstant.Avatars;
  subcategory: T;
  type: AvatarType;
  set: AvatarSet;
  index: number;
  isVisible: boolean;
  visual: AvatarVisual<T>;
  position?: {
    y: number;
  };
  price?: {
    ace: number;
  };
};
